export const mapToISODateFormat = dateFormat => {
  return dateFormat.replace('dddd', 'eeee');
};
